import * as types from '../actions/unusualRecordingsAction';

const initialState = {
  restaurantUuid: 'select',
  startDate: null,
  endDate: null,
  timeInterval: null,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  limit: '20',
  search: '',
  loading: true,
  cursorDirection: 'FIRST',
  cursor: null,
  existNext: false,
  existPrevious: false,
  recordings: [],
  camerasPreviousRequest: null,
};

const unusualRecordingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_UNUSUAL_RECORDINGS_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.CHANGE_UNUSUAL_RECORDINGS_SEVERAL_VALUES:
      return {
        ...state,
        ...action.payload,
      };

    case types.GET_UNUSUAL_RECORDINGS: {
      return {
        ...state,
        loading: true,
      };
    }

    case types.GET_UNUSUAL_RECORDINGS_SUCCESS: {
      const preparedRecordings = action.payload.content.map((item) => ({
        ...item,
        metadata: JSON.parse(item.metadata),
        preview: { image: null, loading: true, error: false },
        isDownloading: false,
        progress: 0,
        controller: null,
      }));
      return {
        ...state,
        loading: false,
        cursor: action.payload.cursor,
        cursorDirection: action.payload.cursorDirection,
        existNext: action.payload.existsNextPage,
        existPrevious: action.payload.existsPreviousPage,
        recordings:
          action.params.cursorDirection === 'NEXT'
            ? [...state.recordings, ...preparedRecordings]
            : preparedRecordings,
      };
    }

    case types.GET_UNUSUAL_RECORDINGS_ERROR: {
      return {
        ...state,
        loading: false,
      };
    }

    case types.SET_UNUSUAL_RECORDING_PREVIEW: {
      return {
        ...state,
        recordings: state.recordings.map((recording) =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                preview: action.payload.preview,
              }
            : recording
        ),
      };
    }

    case types.DOWNLOAD_UNUSUAL_RECORDING: {
      return {
        ...state,
        recordings: state.recordings.map((recording) =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                isDownloading: true,
                progress: 0,
                controller: action.payload.controller,
              }
            : recording
        ),
      };
    }

    case types.DOWNLOAD_UNUSUAL_RECORDING_SUCCESS:
    case types.DOWNLOAD_UNUSUAL_RECORDING_ERROR: {
      return {
        ...state,
        recordings: state.recordings.map((recording) =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                isDownloading: false,
                progress: 0,
                controller: null,
              }
            : recording
        ),
      };
    }

    case types.SET_UNUSUAL_RECORDING_PROGRESS: {
      return {
        ...state,
        recordings: state.recordings.map((recording) =>
          recording.uuid === action.payload.uuid
            ? {
                ...recording,
                progress: action.payload.progress,
              }
            : recording
        ),
      };
    }

    case types.RESET_UNUSUAL_RECORDINGS_STORE:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};

export default unusualRecordingsReducer;
